import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { OptionsTable } from 'projects/access-control/src/app/Domain/Entities/options-table.interface';
import openActionsTable from '../../animations/openActionsTable';

@Component({
	selector: 'app-actions-table',
	animations: [openActionsTable],
	templateUrl: './actions-table.component.html',
	styleUrls: ['./actions-table.component.scss'],
})
export class ActionsTableComponent implements OnInit {
	@Output() private action = new EventEmitter();
	@Input() value: any;
	@Input() optionsTable: OptionsTable[] = [];
	public isOpenMenu: boolean = false;

	constructor() {}

	ngOnInit(): void {}

	public toggleMenu(): void {
		this.isOpenMenu = !this.isOpenMenu;
	}

	public onClickAction(action: string) {
		this.isOpenMenu = !this.isOpenMenu;
		this.action.emit({ action, value: this.value });
	}
}
